module.exports = __webpack_public_path__ + "img/panathinaikos-logo-icon.51c025b3.png";